<template>
  <loading v-if="loading" />
  <error-messages
    v-else-if="!loading && errorMessagesGetList.length > 0"
    :show="true"
    :messages="errorMessagesGetList"
  />
  <empty-list
    v-else-if="
      !loading && errorMessagesGetList.length === 0 && items.length === 0
    "
    :srcImage="require(`@/assets/images/FTP-empty.png`)"
    btnText="ایجاد دسترسی FTP"
    @btnCreateClicked="showCreateModal"
  >
    <template v-slot:messages>
      <p>
        <strong>
          از این طریق می‌توانید دسترسی FTP خود را راه‌اندازی کنید.
        </strong>
      </p>
    </template>
    <create-ftp-modal
      :visible="visibleCreateModal"
      @hidden="hiddenCreateModal"
      @createSuccess="getListAccounts"
    />
  </empty-list>
  <main-page-service
    v-else
    title="لیست حساب‌های FTP"
    btnText="ایجاد دسترسی FTP"
    @btnCreateClicked="showCreateModal"
  >
    <b-table
      responsive
      hover
      :items="items"
      :fields="fields"
      table-class="table-list-table"
      thead-tr-class="table-list-thead-tr"
      tbody-tr-class="table-list-tbody-tr"
      caption="IP Server: 185.51.203.21"
      caption-top
    >
      <template #cell(isReadOnly)="data">
        <span v-if="data.item.isReadOnly">خواندنی</span>
        <span v-else>دسترسی کامل</span>
      </template>
      <template #cell(operation)="data">
        <b-button
          size="sm"
          variant="outline-danger"
          class="table-list-operation"
          @click="showDeleteModal(data.item.id)"
        >
          <b-icon icon="trash-fill"></b-icon>
        </b-button>
      </template>
    </b-table>
    <delete-ftp-modal
      :id="idFtpAccount"
      :visible="visibleDeleteModal"
      @hidden="hiddenDeleteModal"
      @deleteSuccess="getListAccounts"
    />
    <create-ftp-modal
      :visible="visibleCreateModal"
      @hidden="hiddenCreateModal"
      @createSuccess="getListAccounts"
    />
  </main-page-service>
</template>

<script>
import CreateFtpModal from "./CreateFtpModal";
import EmptyList from "@/components/EmptyList/EmptyList.vue";
import Loading from "@/components/Loading/Loading.vue";
import MainPageService from "@/components/MainPageService/MainPageService.vue";
import DeleteFtpModal from "./DeleteFtpModal.vue";
import { ftpUserList } from "@/services/service";
import ErrorMessages from "../../../components/ErrorMessages/ErrorMessages.vue";

export default {
  name: "AppFTP",
  components: {
    EmptyList,
    Loading,
    MainPageService,
    CreateFtpModal,
    DeleteFtpModal,
    ErrorMessages
  },
  data() {
    return {
      loading: false,
      items: [],
      fields: [
        {
          key: "username",
          label: "نام کاربری",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "password",
          label: "رمز عبور",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "isReadOnly",
          label: "نوع کاربر",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "operation",
          label: "عملیات",
          thClass: "text-center",
          tdClass: "text-center"
        }
      ],
      errorMessagesGetList: [],
      // create modal data
      visibleCreateModal: false,
      // delete modal data
      visibleDeleteModal: false,
      idFtpAccount: 0
    };
  },
  mounted() {
    this.getListAccounts();
  },
  methods: {
    getListAccounts: async function() {
      this.loading = true;
      const [error, data] = await ftpUserList(this.$route.params.serviceId);
      if (error) {
        this.errorMessagesGetList = error;
        this.loading = false;
      } else {
        if (data.apiStatus === 200) {
          data.apiData.bridges.map(item => {
            item["operation"] = "";
          });
          this.items = [...data.apiData.bridges];
          this.loading = false;
        } else {
          this.loading = false;
          this.errorMessagesGetList = data.apiErrors;
        }
      }
    },
    // create modal method
    showCreateModal: function() {
      this.visibleCreateModal = true;
    },
    hiddenCreateModal: function() {
      this.visibleCreateModal = false;
    },
    // delete modal method
    showDeleteModal: function(id) {
      this.idFtpAccount = id;
      this.visibleDeleteModal = true;
    },
    hiddenDeleteModal: function() {
      this.visibleDeleteModal = false;
    }
  }
};
</script>
